export class Unity {
  nombre: string;
  abreviado: string;
}
